import { useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { api, call } from "@/core/api/client";
import { ENDPOINTS } from "@/core/api/endpoints";
import { QUERY_KEYS } from "@/core/api/query-client";
import { NOTIFICATIONS_REFRESH_MS } from "@/core/constants";

export const NOTIFICATION_PAGE_SIZE = 20;
/** The partner portal shows only messages for brand teams, not the person's customer messages. */
const AUDIENCE = "BRAND_TEAM" as const;

/** The inbox, newest first; also gives the unread count for the bell. Checked again every minute. */
export function useInbox() {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.notifications,
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) =>
      call(
        api.GET(ENDPOINTS.notifications, {
          params: {
            query: {
              limit: NOTIFICATION_PAGE_SIZE,
              audience: AUDIENCE,
              ...(pageParam ? { cursor: pageParam } : {}),
            },
          },
        }),
      ),
    getNextPageParam: (page) => page.meta.nextCursor ?? undefined,
    refetchInterval: NOTIFICATIONS_REFRESH_MS,
  });
}

export function useMarkRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (notificationId: string) =>
      call(api.POST(ENDPOINTS.notificationRead, { params: { path: { notificationId } } })),
    onSettled: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications }),
  });
}

export function useMarkAllRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () =>
      call(api.POST(ENDPOINTS.notificationsReadAll, { params: { query: { audience: AUDIENCE } } })),
    onSettled: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications }),
  });
}
